import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Disable StrictMode to prevent double rendering issues
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Disable service worker in development to prevent hot reload issues
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
} else {
  // Force unregister any existing service workers in development
  serviceWorkerRegistration.unregister();
  
  // Also clear service worker from browser
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
}